import { usePermissions } from '@britishcouncil/react-common';
import { ExaminerRoleEnum, Permission } from 'api';
import { RoutedTabs, useExaminerId } from 'components';
import { ODP_ASSESSMENT_ROLES, ONLINE_SPEAKING_ROLES } from 'const';
import { useHasCompletedOdpAssessmentQuery, useHasRequiredTrainingForOdpQuery } from 'store';

export const Monitoring = () => {
  const examinerId = useExaminerId();
  const { permissions } = usePermissions();
  const hasViewOdpPermission = permissions.includes(Permission.ViewOdp);
  const { data: hasCompletedOdpAssessment } = useHasCompletedOdpAssessmentQuery(examinerId, {
    skip: !hasViewOdpPermission,
  });
  const { data: hasRequiredTrainingForOdp } = useHasRequiredTrainingForOdpQuery(examinerId, {
    skip: !hasViewOdpPermission,
  });

  return (
    <RoutedTabs
      tabsConfig={[
        {
          menuItem: {
            content: 'Speaking',
            icon: 'comment outline',
            'data-testid': 'monitoring-tab-speaking',
          },
          path: 'speaking',
        },
        {
          menuItem: {
            content: 'ODP Monitoring',
            icon: 'comment outline',
            'data-testid': 'monitoring-tab-odp',
          },
          path: 'odp',
          hidden: !hasCompletedOdpAssessment || !hasRequiredTrainingForOdp,
          requiresAnyRole: ODP_ASSESSMENT_ROLES,
          requiresAnyPermission: [Permission.ViewOdp],
        },
        {
          menuItem: {
            content: 'EOR Speaking',
            icon: 'comment outline',
            'data-testid': 'monitoring-tab-eor-speaking',
          },
          path: 'eorspeaking',
          requiresAnyPermission: [Permission.ViewEorMonitoringResults],
        },
        {
          menuItem: {
            content: 'Online Speaking',
            icon: 'comment outline',
            'data-testid': 'monitoring-tab-online-speaking',
          },
          path: 'onlinespeaking',
          requiresAnyRole: ONLINE_SPEAKING_ROLES,
        },
        {
          menuItem: {
            content: 'OSM Writing',
            icon: 'pencil',
            'data-testid': 'monitoring-tab-osm-writing',
          },
          path: 'osm',
          requiresAnyRole: [ExaminerRoleEnum.IELTSWritingStandard],
        },
        {
          menuItem: {
            content: 'Life Skills',
            icon: 'line chart',
            'data-testid': 'monitoring-tab-life-skills',
          },
          path: 'lifeskills',
        },
      ]}
    />
  );
};
